/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fact_Focus_TermInputs */

const en_about_fact_focus_term = /** @type {(inputs: About_Fact_Focus_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our focus`)
};

const lv_about_fact_focus_term = /** @type {(inputs: About_Fact_Focus_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mūsu specializācija`)
};

/**
* | output |
* | --- |
* | "Our focus" |
*
* @param {About_Fact_Focus_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_fact_focus_term = /** @type {((inputs?: About_Fact_Focus_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fact_Focus_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_fact_focus_term(inputs)
	return en_about_fact_focus_term(inputs)
});